import { skipToken, useQuery } from "@tanstack/react-query";
import { getQueryKey } from "@trpc/react-query";
import { create, keyResolver, windowedFiniteBatchScheduler } from "@yornaath/batshit";
import { BATSHIT_MAX_BATCH_SIZE, BATSHIT_WINDOW_MS, FIVE_MINUTES_MS } from "@remi/constants";

import { api, proxyApi } from "~/utils/api";
import { getQueryConfig } from "~/utils/query-config";

// Computed once at module load so Math.random() isn't re-run per render,
// which would change object identity on every render and retrigger react-query config.
const QUERY_CONFIG = getQueryConfig(FIVE_MINUTES_MS);

const organizationsBatcher = create({
  fetcher: (projectIds: number[]) => {
    return proxyApi.projectOrganization.getByProjectIds.query(projectIds);
  },
  resolver: keyResolver("projectId"),
  scheduler: windowedFiniteBatchScheduler({ windowMs: BATSHIT_WINDOW_MS, maxBatchSize: BATSHIT_MAX_BATCH_SIZE }),
});

export const useProjectOrganizations = ({ projectId }: { projectId?: number }) => {
  const queryKey = getQueryKey(api.projectOrganization.getByProjectId, projectId ? { projectId } : undefined);

  return useQuery({
    queryKey,
    queryFn: projectId
      ? async () => {
          const { organizations } = await organizationsBatcher.fetch(projectId);
          return organizations;
        }
      : skipToken,
    ...QUERY_CONFIG,
  });
};
